import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Accordion,
  KeyValue,
  Row,
  Col,
} from '@folio/stripes/components';

const ClearanceInfo = ({ accordionId, user, expanded, onToggle, getLibraryName, getUserNameById }) => {
  const { customFields = {} } = user;
  const { clearancestatus, clearancedate, clearancelibrary, clearanceby } = customFields;

  // Only show if user has clearance data
  if (!clearancestatus || !clearancedate) {
    return null;
  }

  const statusLabel = clearancestatus === 'opt_0' ? 
    <FormattedMessage id="ui-users.clearance.status.cleared" /> : 
    <FormattedMessage id="ui-users.information.status" />;

  const libraryName = getLibraryName(clearancelibrary);

  return (
    <Accordion
      id={accordionId}
      label={<FormattedMessage id="ui-users.clearance.title" />}
      open={expanded}
      onToggle={onToggle}
    >
      <Row>
        <Col xs={3}>
          <KeyValue
            label={<FormattedMessage id="ui-users.clearance.title" />}
            value={statusLabel}
          />
        </Col>
        <Col xs={3}>
          <KeyValue
            label={<FormattedMessage id="ui-users.clearance.date" />}
            value={clearancedate}
          />
        </Col>
        <Col xs={3}>
          <KeyValue
            label={<FormattedMessage id="ui-users.clearance.library" />}
            value={libraryName}
          />
        </Col>
        <Col xs={3}>
          <KeyValue
            label={<FormattedMessage id="ui-users.clearance.clearedBy" />}
            value={getUserNameById(clearanceby)}
          />
        </Col>
      </Row>
    </Accordion>
  );
};

ClearanceInfo.propTypes = {
  accordionId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  getLibraryName: PropTypes.func.isRequired,
  getUserNameById: PropTypes.func.isRequired,
};

export default ClearanceInfo;